import React from 'react'
import { useAudits } from 'src/components/async/model/audit/useAudit'
import { NONE_ID, NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardAuditFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: audits } = useAudits()
  const noAuditValue = {
    value: NONE_ID,
    label: NONE_NAME,
  }
  const filterValues = [
    noAuditValue,
    ...(audits?.getItemsList().map((audit) => ({
      value: audit.getName(),
      label: audit.getName(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_AUDIT}
      filterName={FilterName.DASHBOARD_AUDIT}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
